<button
    title="Clear All Filters"
    mat-stroked-button
    color="primary"
    class="!w-full !h-8 !px-3 !border-primary-700"
    (click)="clearFilters()"
>
    <mat-icon fontSet="material-icons-outlined">filter_alt_off</mat-icon>
    <span class="text-sm tracking-normal text-nowrap">Clear Filters</span>
</button>
